import { ApolloClient, gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';
import { InsightsResponse } from '../Constants/insightTypes';


export interface GetInsightDetailsVars {
    entityType: String;
    entityValue: String;
    insightID: String;
}

export interface GetInsightDetailsVars {
  entityType: String;
  entityValue: String;
  insightID: String;
}

export interface GetInsightDetailsData {
  getInsightDetails:
    | { record?: InsightsResponse }
    | InsightsResponse
    | null;
}

const GET_INSIGHT_DETAILS = gql`
    query getInsightDetails(
            $entityType: String,
            $entityValue: String,
            $insightID: String
        ){
        getInsightDetails(
            entityType: $entityType,
            entityValue: $entityValue,
            insightID: $insightID
        )
    }
`;

export const useGetInsightDetailsQuery = () => {
    return useLazyQuery<AnyObject, GetInsightDetailsVars>(GET_INSIGHT_DETAILS, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only', // Forces new API call every time
        nextFetchPolicy: 'cache-first'
    });
};

export async function fetchDomainInsightDetails(
  client: ApolloClient<object>,
  domainIdent: string,
  insightID: string
): Promise<InsightsResponse> {
  const { data } = await client.query<GetInsightDetailsData, GetInsightDetailsVars>({
    query: GET_INSIGHT_DETAILS,
    variables: { entityType: 'DOMAINIDENT', entityValue: domainIdent, insightID },
    fetchPolicy: 'network-only',
  });

  const payload = data?.getInsightDetails?.record?.fields;
  return payload || [];
}
